import React, { createContext, useEffect, useState } from "react";

export const PointContext = createContext();

const initialState = {
    unlocked: {},
};

export function PointProvider(props) {

    const [point, setPoint] = useState(() => JSON.parse(sessionStorage.getItem("points")) || initialState);
    const [pointNavigation, setPointNavigation] = useState(null);
    const [showPointNavigation, setShowPointNavigation] = useState(true);

    useEffect(() => {
        sessionStorage.setItem("points", JSON.stringify(point));
    }, [point]);


    return <PointContext.Provider value={{
        unlocked: point.unlocked,
        pointNavigation: pointNavigation,
        showPointNavigation: showPointNavigation,

        setUnlockedPoints: (unlocked) => setPoint({ ...point, unlocked}),

        switchPointNavigation: (navigation) => {
            setPointNavigation(navigation);
            console.log("PointContext switch nav to " + navigation);
        },

        setShowPointNavigation: (value) => {
            setShowPointNavigation(value);
        }

    }}
    >
        {props.children}
    </PointContext.Provider>;
}
